/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */
import _round from 'lodash/round'

export const getFormattedAmount = value => {
  const rounded = _round(value, 2)
  const roundedString = rounded.toString()
  const [whole, fraction] = roundedString.split('.')

  if (!fraction) {
    return `${whole}.00`
  }

  if (fraction.length === 2) {
    return roundedString
  }

  return `${whole}.${fraction}0`
}

const getDigitsFromValue = value => value.replace(/(-(?!\d))|[^0-9|-]/g, '')

const padDigits = digits => {
  const desiredLength = 3
  const actualLength = digits.length

  if (actualLength >= desiredLength) {
    return digits
  }

  const amountToAdd = desiredLength - actualLength
  const padding = '0'.repeat(amountToAdd)

  return padding + digits
}

const removeLeadingZeros = num => num.replace(/^0+([0-9]+)/, '$1')

const addDecimalToNumber = (num, separator) => {
  const centsStartingPosition = num.length - 2
  const dollars = removeLeadingZeros(num.substring(0, centsStartingPosition))
    .replace(/,/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  const cents = num.substring(centsStartingPosition)
  return dollars + separator + cents
}

export const toCurrency = (value, separator = '.') => {
  if (!value) return ''
  const digits = getDigitsFromValue(typeof value === 'string' ? value : `${value.toFixed(2)}`)
  const digitsWithPadding = padDigits(digits)
  return addDecimalToNumber(digitsWithPadding, separator)
}
